const SvgIp = props => (
  <svg height="1em" viewBox="0 0 14 18" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-2 0h18v18H-2z" />
      <path
        d="M4.8 8.068a2.054 2.054 0 1 1 4.106.001A2.054 2.054 0 0 1 4.8 8.068z"
        stroke="currentColor"
      />
      <path
        d="M.5 7.853a6.353 6.353 0 1 1 12.706 0c0 4.664-6.353 9.646-6.353 9.646S.5 12.517.5 7.853z"
        stroke="currentColor"
      />
    </g>
  </svg>
)

export default SvgIp
